globalThis.Camera = class Camera {
  constructor() {
    this.mousedown = false;
    this.startpos = null;
    this.startworldpos = null;
    this.abort = new AbortController();
    addEventListener("mousedown", this.onMousedown.bind(this), this.abort);
    addEventListener("mouseup", this.onMouseup.bind(this), this.abort);
    addEventListener("mousemove", this.onMousemove.bind(this), this.abort);
    document.addEventListener("wheel", this.onWheel.bind(this), this.abort);
    requestAnimationFrame(this.step.bind(this));
  }

  remove() {
    this.abort.abort();
  }

  onMousedown(event) {
    if (!globalThis.TOPBAR.hasControl("camera")) return;
    this.mousedown = true;
    document.body.classList.add("grabbing");
    this.startpos = new Vector2(event.clientX, event.clientY);
    this.startworldpos = globalThis.WORLD.position.clone();
  }

  onMouseup() {
    if (!globalThis.TOPBAR.hasControl("camera")) return;
    document.body.classList.remove("grabbing");
    this.mousedown = false;
    this.startpos = null;
    this.startworldpos = null;
  }

  onMousemove() {
    if (!globalThis.TOPBAR.hasControl("camera")) return;
    if (!this.mousedown) return;
    const pos = new Vector2(event.clientX, event.clientY);
    const deltaworldpos = pos.clone().sub(this.startpos).div(globalThis.UNIT);
    const worldpos = deltaworldpos.clone().add(this.startworldpos);
    const { x, y } = worldpos;
    globalThis.WORLD.setPosition(x, y);
  }

  onWheel(event) {
    if (!globalThis.TOPBAR.hasControl("camera")) return;
    const out = event.deltaY > 0;
    if (out) globalThis.WORLD.decreaseScale();
    else globalThis.WORLD.increaseScale();
  }

  step() {
    if (this.abort.signal.aborted) return;
    requestAnimationFrame(this.step.bind(this));
    if (globalThis.TOPBAR.hasControl("camera")) return;
    if (globalThis.TOPBAR.hasState("cameralock")) return;
    if (!globalThis.WORLD.hasOwnPlayers()) return;
    const distance = globalThis.WORLD.getOwnPlayersDistance();
    const scale = 30 / distance;
    globalThis.WORLD.setScale(scale);
    const center = globalThis.WORLD.getOwnPlayersCenter();
    const { x, y } = center
      .sub(globalThis.WORLD.size.clone().div(2))
      .mul(globalThis.WORLD.scale);
    globalThis.WORLD.setPosition(-x, -y);
  }
};
